<template>
  <div>
    <v-dialog scrollable v-model="editDialog" persistent max-width="800px">
      <material-card
        v-if="editedItem !== null && editedItem !== undefined"
        :title="
          editedIndex > -1
            ? $t('components.inmemorymembergroups.edit_group_{0}', [
                trans(editedItem, 'Name'),
              ])
            : $t('components.inmemorymembergroups.add_group')
        "
        icon="edit"
        :color="editedIndex > -1
            ? $vuetify.theme.themes.light.primary
            : $vuetify.theme.themes.light.success"
      >
        <v-card-text>
          <v-form ref="form" v-model="valid">
            <v-container fluid grid-list-md>
              <v-row>
                <v-col cols="12" sm="6" align-self-end>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-container pa-0>
                        <v-row no-gutters>
                          <v-col>
                            <trans-textbox
                              v-model="editedItem"
                              :label="$t('globals.name')"
                              :rules="[$rules.required]"
                              class="required"
                              field="Name"
                              :dialog="editDialog"
                            ></trans-textbox>
                          </v-col>
                          <v-col
                            style="margin-top: 20px; margin-left: 3px"
                            cols="auto"
                          >
                            <v-icon v-bind="attrs" v-on="on">help</v-icon>
                          </v-col>
                        </v-row>
                      </v-container>
                    </template>
                    <span>
                      {{ $t("components.inmemorymembergroups.name_tooltip") }}
                    </span>
                  </v-tooltip>
                </v-col>

                <v-col cols="12" sm="6" align-self-end>
                  <no-autocomplete-textfield
                    v-model="editedItem.Order"
                    :label="$t('globals.order')"
                    :rules="[$rules.requiredNum]"
                    class="required"
                    type="number"
                    min="0"
                  ></no-autocomplete-textfield>
                </v-col>

                <v-col cols="12" sm="6" align-self-end>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-container pa-0>
                        <v-row no-gutters>
                          <v-col>
                            <trans-textbox
                              v-model="editedItem"
                              :label="$t('globals.kind')"
                              :rules="[$rules.required]"
                              class="required"
                              field="Kind"
                              :dialog="editDialog"
                            ></trans-textbox>
                          </v-col>
                          <v-col
                            style="margin-top: 20px; margin-left: 3px"
                            cols="auto"
                          >
                            <v-icon v-bind="attrs" v-on="on">help</v-icon>
                          </v-col>
                        </v-row>
                      </v-container>
                    </template>
                    <span>
                      {{ $t("components.inmemorymembergroups.kind_tooltip") }}
                    </span>
                  </v-tooltip>
                </v-col>
                <v-col cols="12" sm="6" align-self-end>
                  <trans-multi-select2
                    v-model="editedItem.CoverageIdentities"
                    :items="coverage"
                    :label="$t('globals.coverage')"
                    itemValue="Identifier"
                    field="Name"
                    multiple
                    :rules="[$rules.atLeastOne]"
                    class="required"
                    :displayFunc="
                      (item, str) =>
                        `${str} (${truncate(trans(item, 'Description'), 40)})`
                    "
                  ></trans-multi-select2>
                </v-col>
                <v-col cols="12" align-self-end>
                  <trans-textarea
                    v-model="editedItem"
                    :label="$t('globals.description')"
                    field="Description"
                    :dialog="editDialog"
                    :rules="[$rules.required]"
                    class="required"
                  ></trans-textarea>
                </v-col>
                <v-col cols="12" md="3">
                  <trans-multi-select2
                    v-model="editedItem.Employers"
                    :items="employers"
                    :label="$t('globals.employers')"
                    item-value="Identifier"
                    field="Name"
                    multiple
                  ></trans-multi-select2>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="close">{{ $t("globals.cancel") }}</v-btn>
          <v-btn :disabled="!valid" color="primary" @click="save">
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog scrollable v-model="deleteDialog" persistent max-width="400">
      <material-card
        v-if="editedItem"
        :title="
          $t('components.inmemorymembergroups.remove_member_group_{0}', [
            trans(editedItem, 'Name'),
          ])
        "
        :color="$vuetify.theme.themes.light.error"
        icon="delete"
      >
        <v-card-text>
          {{ $t("globals.are_you_sure") }}
        </v-card-text>
        <v-card-actions>
          <v-btn color text @click="deleteDialog = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn color="primary" text @click="tryDelete">
            {{ $t("globals.remove") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <material-card
    :title="$t('globals.member_groups')"
      :color="$vuetify.theme.themes.light.secondary"
      icon="group_work"
    >
      <pbas-data-table
        ref="table"
        :dataProvider="provider"
        :rowActions="rowActions"
        :floatActions="floatActions"
        fileNamePrefix="member-groups"
        :identifier="identifier"
        @error="error = $event"
      ></pbas-data-table>
    </material-card>
    <error-handler :error="error"></error-handler>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ErrorHandler from "@/components/ErrorHandler";
import { InMemoryProvider } from "pbas-vue-components";
import InMemoryMemberGroupsPlanCreationHeaders from "@/headers/BuilderMemberGroups";
import TransTextbox from "@/components/TransTextbox";
import TransTextarea from "@/components/TransTextarea";
import { translate2 } from "@/trans2";
import TransMultiSelect2 from "@/components/TransMultiSelect2";
import NoAutocompleteTextfield from "@/components/NoAutocompleteTextfield";

export default {
  components: {
    ErrorHandler,
    TransTextbox,
    TransTextarea,
    TransMultiSelect2,
    NoAutocompleteTextfield,
  },
  props: [
    "memberGroups",
    "coverage",
    "identifier",
    "planIdentityId",
    "disabled",
    "employers",
  ],
  data() {
    return {
      floatActions: [
        {
          name: "addMemberGroup",
          icon: "add",
          color: this.$vuetify.theme.themes.light.success,
          text: "globals.add_new",
          handler: () => this.addItem(),
          visible: () => !this.disabled,
        },
      ],
      error: null,
      provider: undefined,
      rowActions: [
        {
          name: "edit",
          icon: "edit",
          title: "globals.edit",
          handler: (item) => this.editItem(item),
          visible: () => !this.disabled,
        },
        {
          name: "remove",
          icon: "delete",
          title: "globals.remove",
          handler: (item) => {
            const obj = this.provider.items.filter(
              (o) => o.Identifier === item.Identifier
            )[0];
            this.editedIndex = this.provider.items.indexOf(obj);
            this.editedItem = item;
            this.deleteDialog = true;
          },
          visible: () => !this.disabled,
        },
      ],
      editDialog: false,
      deleteDialog: false,
      valid: true,
      headers: InMemoryMemberGroupsPlanCreationHeaders,
      editedIndex: -1,
      editedItem: null,
      // employerCoverage: [],
    };
  },
  computed: {
    ...mapGetters("common", ["language"]),
  },
  watch: {
    memberGroups: {
      handler(v) {
        if (this.provider) {
          console.log(v);
          this.provider.items = v;
          this.$refs.table.getDataAsync();
        }
      },
    },
    // "editedItem.Employers": {
    //   handler(v) {
    //     if (v && v.length > 0) {
    //       this.employerCoverage = this.coverage.filter((o) =>
    //         v.some((e) =>
    //         (o.Employers && o.Employers.length > 0 && o.Employers.some((ee) => e.Identifier === ee.Identifier)) || !o.Employers
    //         )
    //       );
    //     } else {
    //       this.employerCoverage = this.coverage.filter((o) => true);
    //     }
    //   },
    //   deep: true,
    // },
  },
  mounted() {
    this.loadPlanData();
  },
  methods: {
    truncate(str, n, useWordBoundary) {
      if (str.length <= n) {
        return str;
      }
      const subString = str.substr(0, n - 1); // the original check
      return (
        (useWordBoundary
          ? subString.substr(0, subString.lastIndexOf(" "))
          : subString) + "..."
      );
    },
    async tryDelete() {
      this.provider.items.splice(this.editedIndex, 1);
      this.deleteDialog = false;
      this.$refs.table.getDataAsync();
      this.$emit("update-member-groups", this.provider.items);
    },
    trans(item, field) {
      return translate2(item, field);
    },
    reload() {
      this.$refs.table.getDataAsync();
    },
    async loadPlanData() {
      try {
        console.log(this.memberGroups);
        this.provider = new InMemoryProvider(this.memberGroups, this.headers);
      } catch (error) {
        this.error = error;
      }
    },
    validate() {
      if (this.$refs.form && this.$refs.form.validate()) {
        return true;
      }
      return false;
    },
    async editItem(item) {
      const obj = this.provider.items.filter(
        (o) => o.Identifier === item.Identifier
      )[0];
      this.editedIndex = this.provider.items.indexOf(obj);
      this.editedItem = JSON.parse(JSON.stringify(item));
      // if (this.editedItem.Employers && this.editedItem.Employers.length > 0) {
      //   this.employerCoverage = this.coverage.filter((o) =>
      //     this.editedItem.Employers.some((e) =>
      //       (o.Employers && o.Employers.length > 0 && o.Employers.some((ee) => e.Identifier === ee.Identifier)) || !o.Employers
      //     )
      //   );
      // } else {
      //   this.employerCoverage = this.coverage.filter((o) => true);
      // }
      let coverageIdentities = [];
      if (this.editedItem.CoverageIdentities) {
        for (let c of this.editedItem.CoverageIdentities) {
          let coverage = this.coverage.filter(
            (o) => o.Identifier === c.Identifier
          )[0];
          coverageIdentities.push(coverage);
        }
      }
      this.editedItem.CoverageIdentities = coverageIdentities;
      this.editDialog = true;
    },
    async addItem() {
      const item = {
        Translations: [],
        Identifier: Math.random().toString(),
      };
      this.editedIndex = -1;
      this.editedItem = JSON.parse(JSON.stringify(item));
      if (this.coverage.length === 1) {
        this.editedItem.CoverageIdentities = [this.coverage[0]];
      }
      // this.employerCoverage = this.coverage.filter((o) => true);
      this.editDialog = true;
    },
    close() {
      this.editDialog = false;
      this.editedItem = null;
      this.editedIndex = -1;
      this.$refs.form.resetValidation();
    },
    save() {
      this.editedItem.PlanId = this.planIdentityId;
      this.editedItem.CoverageIdentities =
        this.editedItem.CoverageIdentities.filter(
          (o) => o !== null && o !== undefined
        );
      for (let ci of this.editedItem.CoverageIdentities) {
        ci.Id = ci.IdentityId;
        ci.Current = {
          Translations: ci.Translations,
        };
      }
      if (this.editedIndex > -1) {
        this.update();
      } else {
        this.add();
      }
    },
    async update() {
      this.editedItem.Name = this.editedItem.Translations.filter(
        (o) => o.LanguageCode === this.language.language
      )[0].Name;
      this.editedItem.Description = this.editedItem.Translations.filter(
        (o) => o.LanguageCode === this.language.language
      )[0].Description;
      this.editedItem.Kind = this.editedItem.Translations.filter(
        (o) => o.LanguageCode === this.language.language
      )[0].Kind;
      // this.editedItem.Translations.forEach((t) => {
      //   delete t.Id;
      // });
      // this.editedItem.edited = true;
      // this.addToChanged(this.editedItem);
      this.provider.items[this.editedIndex] = JSON.parse(
        JSON.stringify(this.editedItem)
      );
      this.close();
      this.$refs.table.getDataAsync();
      this.$emit("update-member-groups", this.provider.items);
    },
    async add() {
      this.editedItem.Name = this.editedItem.Translations.filter(
        (o) => o.LanguageCode === this.language.language
      )[0].Name;
      this.editedItem.Description = this.editedItem.Translations.filter(
        (o) => o.LanguageCode === this.language.language
      )[0].Description;
      this.editedItem.Kind = this.editedItem.Translations.filter(
        (o) => o.LanguageCode === this.language.language
      )[0].Kind;
      // const changes = this.changed.filter(
      //   (o) => o.FakeId === this.editedItem.FakeId
      // );
      // if (changes.length > 0) {
      //   const changedIndex = this.changed.indexOf(changes[0]);
      //   this.changed[changedIndex] = JSON.parse(
      //     JSON.stringify(this.editedItem)
      //   );
      // } else {
      //   this.editedItem.FakeId = Math.random();
      //   this.changed.push(JSON.parse(JSON.stringify(this.editedItem)));
      // }
      // this.editedItem.added = true;

      this.provider.items.push(JSON.parse(JSON.stringify(this.editedItem)));
      this.close();
      this.$refs.table.getDataAsync();
      this.$emit("update-member-groups", this.provider.items);
    },
  },
};
</script>
